/* eslint-disable no-unused-vars */
function setConfiguration(data) {
    window.hippoConfig.configuration = data;
    // TODO: either use webpack friendly something to have an npm module here.. or find a bower one (or write one?) just get rid of this ugliness..
    const stateAbbreviations = {
        AL: 'Alabama',
        AK: 'Alaska',
        AZ: 'Arizona ',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VA: 'Virginia ',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming'
    };
    const supportedStatesAbrv = data.supported_states
        .map((s) => s.split('_')[0])
        .filter((elem, pos, arr) => arr.indexOf(elem) === pos)
        .sort();

    window.hippoConfig.hippoConst.LICENSE_DETAILS = {};
    // build LICENSES on hippoConfig.. hippoConsts.LICENSE_DETAILS.AZ = {NAME: 'Arizona', LICENSE: '37843784'}
    const licenseKeys = Object.keys(data.licenses);
    supportedStatesAbrv.forEach((state) => {
        const { abrv, licenses } = licenseKeys
            .filter((key) => key.indexOf(state) === 0)
            .reduce(
                (obj, key) => {
                    const [abrv, license] = data.licenses[key].split(' ');
                    obj.abrv = abrv;
                    if (!obj.licenses.includes(license)) {
                        obj.licenses.push(license);
                    }
                    return obj;
                },
                {
                    licenses: []
                }
            );

        let licensesString;

        if (licenses.length > 1) {
            licensesString = '#' + licenses.join(', #'); // simplest way of working with the current code while making the data source itself more correct
        } else {
            licensesString = '#' + licenses[0];
        }

        const licenseDetail = {
            ABRV: abrv.toUpperCase(),
            NAME: stateAbbreviations[abrv.toUpperCase()].trim(),
            LICENSE: licensesString
        };
        window.hippoConfig.hippoConst.LICENSE_DETAILS[abrv.toUpperCase()] = licenseDetail;
    });
}

(function () {
    const { _ } = window;
    _.merge(window.hippoConfig, window.appConfig); // join with EFI configuration
    document.open();
    const strParams = window.location.search;
    const queryParams = strParams.substring(strParams[0] === '?' ? 1 : 0);
    document.write(
        `<script src="${window.hippoConfig.API_HOST}/v1/configuration/?callback=setConfiguration&${queryParams}" type="text/javascript" referrerpolicy="origin"></script>`
    );
    document.close();
})();
